// src/Dashboard/pages/user/DashboardUser/components/DashboardUserHeader.jsx

import React from "react";
import { FaBell, FaBullseye, FaEnvelope, FaMoneyBillAlt } from "react-icons/fa";

function HeaderStat({ icon: Icon, label, value, tone }) {
  const toneMap = {
    amber:
      "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-200 dark:ring-amber-800/50",
    violet:
      "bg-violet-50 text-violet-700 ring-violet-200 dark:bg-violet-900/20 dark:text-violet-200 dark:ring-violet-800/50",
    rose: "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-900/20 dark:text-rose-200 dark:ring-rose-800/50",
    emerald:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/50",
  };

  return (
    <div
      className={`rounded-2xl p-4 ring-1 ${
        toneMap[tone] || toneMap.violet
      }`}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/75 text-base shadow-sm dark:bg-slate-950/30">
          <Icon />
        </span>
        <div>
          <p className="text-xs font-semibold opacity-80">{label}</p>
          <p className="text-2xl font-bold">{Number(value || 0)}</p>
        </div>
      </div>
    </div>
  );
}

export default function DashboardUserHeader({ user, counts }) {
  const fullName = `${user?.prenom || user?.first_name || ""} ${
    user?.nom || user?.last_name || ""
  }`.trim();

  return (
    <section className="overflow-hidden rounded-[30px] border border-slate-200 bg-white/80 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
      <div className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#0f5cc0] px-5 py-7 text-white sm:px-7">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(76,168,47,0.25),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.18),transparent_30%)]" />

        <div className="relative">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/65">
            Tableau de bord personnel
          </p>
          <h1 className="mt-2 text-2xl font-bold sm:text-3xl font-montserrat">
            Bonjour {fullName || "à vous"}
          </h1>
          <p className="mt-2 max-w-3xl text-sm leading-6 text-white/85">
            Une synthèse rapide de vos règlements, messages, notifications,
            objectifs, inscriptions aux évènements et favoris.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2 lg:grid-cols-4 sm:p-6">
        <HeaderStat
          icon={FaMoneyBillAlt}
          label="Règlements à effectuer"
          value={counts?.payments?.total}
          tone="amber"
        />
        <HeaderStat
          icon={FaEnvelope}
          label="Messages non lus"
          value={counts?.messages?.unread}
          tone="violet"
        />
        <HeaderStat
          icon={FaBell}
          label="Notifications non lues"
          value={counts?.notifications?.unread}
          tone="rose"
        />
        <HeaderStat
          icon={FaBullseye}
          label="Objectifs en cours"
          value={counts?.objectifs?.total}
          tone="emerald"
        />
      </div>
    </section>
  );
}